import React from 'react'
import classNames from 'classnames'

import { Centre, WithNavigationMenu } from '../types'

import style from './index.scss'
import { CentreSelector } from './centre-selector'
import Nav from '.'

const Main: React.FC<{
  centres?: Array<Centre>
  centre?: Centre
  shop?: WithNavigationMenu
  giftCards?: WithNavigationMenu
  onClose: () => void
}> = ({ centres, centre, shop, giftCards, onClose }) => {
  const findACentreNodes =
    centres &&
    (() => {
      const centresByRegion = centres.reduce<{ [key: string]: Array<Centre> }>(
        (acc, c) => {
          let arr = acc[c.state]
          if (!arr) {
            arr = []
            acc[c.state] = arr
          }
          arr.push(c)
          return acc
        },
        {}
      )

      return [
        () => <CentreSelector centres={centres} centre={centre} />,
        () => (
          <div className={classNames(style.subtitle, style.regions)}>
            Regions
          </div>
        ),
        ...[
          ['ACT', 'Australian Capital Territory'],
          ['NSW', 'New South Wales'],
          ['QLD', 'Queensland'],
          ['SA', 'South Australia'],
          ['VIC', 'Victoria'],
          ['WA', 'Western Australia'],
          ['AUCKLAND', 'Auckland'],
          ['CHRISTCHURCH', 'Christchurch'],
        ]
          .filter(([key]) => centresByRegion[key])
          .map(([key, title]) => ({
            title,
            items: centresByRegion[key].map(c => ({
              label: c.title,
              url: `/${c.slug}`,
            })),
          })),
      ]
    })()

  const items = [
    shop && {
      title: 'Shop online',
      items: shop.navigationMenu,
      className: classNames(style['item-big']),
    },
    centre
      ? {
          title: centre.title,
          items: centre.navigationMenu,
          className: classNames(style['item-big']),
        }
      : findACentreNodes && {
          title: 'Find a centre',
          items: findACentreNodes,
          className: classNames(style['item-big']),
        },
    giftCards && {
      title: 'Gift Cards',
      items: giftCards.navigationMenu,
      className: classNames(style['item-big']),
    },
    // {
    //  label: 'The Edit',
    //  url: '/the-edit',
    //  className: classNames(style['item-big']),
    // },
    {
      label: 'Westfield Plus',
      url: '/westfield-plus',
      className: classNames(style['item-big']),
    },
    () => <br />,
    centre &&
      findACentreNodes && {
        title: 'Find a centre',
        items: findACentreNodes,
      },
    {
      label: 'Customer Support',
      url: 'https://support.westfield.com.au/',
    },
  ]

  return <Nav items={items} onClose={onClose} />
}

export default Main
